/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EnumerationValueDto } from './EnumerationValueDto';
import {
    EnumerationValueDtoFromJSON,
    EnumerationValueDtoFromJSONTyped,
    EnumerationValueDtoToJSON,
} from './EnumerationValueDto';
import type { NumericValueDto } from './NumericValueDto';
import {
    NumericValueDtoFromJSON,
    NumericValueDtoFromJSONTyped,
    NumericValueDtoToJSON,
} from './NumericValueDto';

/**
 * 
 * @export
 * @interface BeamShapingGroupRectangularDto
 */
export interface BeamShapingGroupRectangularDto {
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupRectangularDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupRectangularDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupRectangularDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupRectangularDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof BeamShapingGroupRectangularDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldShape?: EnumerationValueDto;
    /**
     * 
     * @type {EnumerationValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldSymmetry?: EnumerationValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldSizeX?: NumericValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldSizeY?: NumericValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldEdgeX1?: NumericValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldEdgeX2?: NumericValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldEdgeY1?: NumericValueDto;
    /**
     * 
     * @type {NumericValueDto}
     * @memberof BeamShapingGroupRectangularDto
     */
    radiationFieldEdgeY2?: NumericValueDto;
    /**
     * 
     * @type {string}
     * @memberof BeamShapingGroupRectangularDto
     */
    $type?: BeamShapingGroupRectangularDtoTypeEnum;
}


/**
 * @export
 */
export const BeamShapingGroupRectangularDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersBeamShapingGroupRectangularDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type BeamShapingGroupRectangularDtoTypeEnum = typeof BeamShapingGroupRectangularDtoTypeEnum[keyof typeof BeamShapingGroupRectangularDtoTypeEnum];


/**
 * Check if a given object implements the BeamShapingGroupRectangularDto interface.
 */
export function instanceOfBeamShapingGroupRectangularDto(value?: unknown): value is BeamShapingGroupRectangularDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamShapingGroupRectangularDtoTypeEnum)[0];
}

export function BeamShapingGroupRectangularDtoFromJSON(json: any): BeamShapingGroupRectangularDto {
    return BeamShapingGroupRectangularDtoFromJSONTyped(json, false);
}

export function BeamShapingGroupRectangularDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamShapingGroupRectangularDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'groupHash': !exists(json, 'groupHash') ? undefined : json['groupHash'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'radiationFieldShape': !exists(json, 'radiationFieldShape') ? undefined : EnumerationValueDtoFromJSON(json['radiationFieldShape']),
        'radiationFieldSymmetry': !exists(json, 'radiationFieldSymmetry') ? undefined : EnumerationValueDtoFromJSON(json['radiationFieldSymmetry']),
        'radiationFieldSizeX': !exists(json, 'radiationFieldSizeX') ? undefined : NumericValueDtoFromJSON(json['radiationFieldSizeX']),
        'radiationFieldSizeY': !exists(json, 'radiationFieldSizeY') ? undefined : NumericValueDtoFromJSON(json['radiationFieldSizeY']),
        'radiationFieldEdgeX1': !exists(json, 'radiationFieldEdgeX1') ? undefined : NumericValueDtoFromJSON(json['radiationFieldEdgeX1']),
        'radiationFieldEdgeX2': !exists(json, 'radiationFieldEdgeX2') ? undefined : NumericValueDtoFromJSON(json['radiationFieldEdgeX2']),
        'radiationFieldEdgeY1': !exists(json, 'radiationFieldEdgeY1') ? undefined : NumericValueDtoFromJSON(json['radiationFieldEdgeY1']),
        'radiationFieldEdgeY2': !exists(json, 'radiationFieldEdgeY2') ? undefined : NumericValueDtoFromJSON(json['radiationFieldEdgeY2']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function BeamShapingGroupRectangularDtoToJSON(value?: BeamShapingGroupRectangularDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'name': value.name,
        'groupName': value.groupName,
        'groupHash': value.groupHash,
        'origin': EntityOriginToJSON(value.origin),
        'radiationFieldShape': EnumerationValueDtoToJSON(value.radiationFieldShape),
        'radiationFieldSymmetry': EnumerationValueDtoToJSON(value.radiationFieldSymmetry),
        'radiationFieldSizeX': NumericValueDtoToJSON(value.radiationFieldSizeX),
        'radiationFieldSizeY': NumericValueDtoToJSON(value.radiationFieldSizeY),
        'radiationFieldEdgeX1': NumericValueDtoToJSON(value.radiationFieldEdgeX1),
        'radiationFieldEdgeX2': NumericValueDtoToJSON(value.radiationFieldEdgeX2),
        'radiationFieldEdgeY1': NumericValueDtoToJSON(value.radiationFieldEdgeY1),
        'radiationFieldEdgeY2': NumericValueDtoToJSON(value.radiationFieldEdgeY2),
        '$type': value.$type,
    });
}

